var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('home-section',{attrs:{"id":"home-section","currentPage":"home","isWebView":_vm.IsWebView}}),(!_vm.IsWebView)?_c('download-section'):_vm._e(),(!_vm.IsWebView)?_c('about-section'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }